import {useEffect} from 'react'
import {ConfirmSegregateModalHeader} from './ConfirmSegregateModalHeader'
import {ConfirmSegregateModalForm} from './ConfirmSegregateModalForm'

export const ConfirmSegregateModal = ({ setOpenConfirmSegregateModal, handleSegregate, isLoading, listing}) => {

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className={`modal-dialog modal-dialog-centered mw-600px`}>
          <div className='modal-content'>
            <ConfirmSegregateModalHeader setOpenConfirmSegregateModal={setOpenConfirmSegregateModal} listing={listing} />
            <div className={`modal-body scroll-y mx-5`}>
            <ConfirmSegregateModalForm setOpenConfirmSegregateModal={setOpenConfirmSegregateModal} handleSegregate={handleSegregate} isLoading={isLoading} />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'/>
    </>
  )
}
